Ext.define('SA.HistogramAttributes', {
    singleton: true,

    isSupported({attribute, censusRelease}) {
        var isPolygonAttribute = SA.data.AttributesCache.isPolygonAttribute(attribute),
            isInCensusRelease = SA.data.AttributesCache.hasCensusRelease(attribute, censusRelease);

        return isPolygonAttribute && isInCensusRelease;
    }
});